module.exports = __webpack_public_path__ + "static/media/attendees.683c69e8.png";